import {
  build_manual_mapping_questions,
  build_manual_mapping_section_payload,
  build_manual_review_sections_from_form_sections,
  find_submitted_answer_for_mapping,
  manual_mappings_have_onboarding_links,
  pick_manual_mappings_from_items
} from '@/views/onboarding_system_views/Gates/Verification/manage_verification_manual_helpers';
import { normalize_label as normalize_verification_label } from '@/views/onboarding_system_views/Gates/Verification/manage_verification_helpers';

export function get_manual_field_runs(item = {}) {
  const field_runs = item?.field_runs || item?.manual_run?.field_runs;
  return Array.isArray(field_runs) ? field_runs : [];
}

export function build_historical_manual_review_sections(manual_item = {}, case_form_sections = [], documents = []) {
  const manual_form_sections = Array.isArray(manual_item?.manual_form_sections)
    ? manual_item.manual_form_sections
    : [];
  const manual_mappings = Array.isArray(manual_item?.manual_mappings) ? manual_item.manual_mappings : [];
  if (manual_mappings_have_onboarding_links(manual_mappings)) {
    const questions = build_manual_mapping_questions(
      manual_mappings,
      (mapping) => find_submitted_answer_for_mapping(
        case_form_sections,
        mapping,
        normalize_verification_label,
        documents
      )
    );

    return build_manual_mapping_section_payload(manual_item, questions);
  }

  if (manual_form_sections.length) {
    return build_manual_review_sections_from_form_sections(
      manual_item,
      manual_form_sections,
      manual_mappings,
      (mapping) => find_submitted_answer_for_mapping(
        case_form_sections,
        mapping,
        normalize_verification_label,
        documents
      )
    );
  }

  if (!manual_mappings.length) return [];

  const questions = build_manual_mapping_questions(
    manual_mappings,
    (mapping) => find_submitted_answer_for_mapping(
      case_form_sections,
      mapping,
      normalize_verification_label,
      documents
    )
  );

  return build_manual_mapping_section_payload(manual_item, questions);
}

function get_manual_item_type(item = {}) {
  return String(item?.verification_type || '').trim().toLowerCase();
}

function manual_item_has_saved_run(item = {}) {
  return Boolean(
    Number(item?.run_id || item?.manual_run?.id || item?.manual_run?.run_id || 0)
    || item?.manual_run
  );
}

function manual_item_has_review_shape(item = {}) {
  return Boolean(
    Array.isArray(item?.manual_form_sections) && item.manual_form_sections.length
    || Array.isArray(item?.manual_mappings) && item.manual_mappings.length
    || item?.manual_binding
  );
}

function pick_array_value(primary_item = {}, support_item = {}, key = '') {
  const primary_value = Reflect.get(primary_item, key);
  if (Array.isArray(primary_value) && primary_value.length) {
    return primary_value;
  }

  const support_value = Reflect.get(support_item, key);
  return Array.isArray(support_value) ? support_value : [];
}

function merge_manual_items(primary_item = null, support_item = null) {
  if (!primary_item) return support_item || null;
  if (!support_item) return primary_item;

  return {
    ...support_item,
    ...primary_item,
    manual_binding: primary_item?.manual_binding || support_item?.manual_binding || null,
    manual_mappings: pick_manual_mappings_from_items(primary_item, support_item),
    manual_form_sections: pick_array_value(primary_item, support_item, 'manual_form_sections'),
    field_runs: pick_array_value(primary_item, support_item, 'field_runs'),
    manual_run: primary_item?.manual_run || support_item?.manual_run || null
  };
}

function is_matching_support_item(run_backed_item, item) {
  return item !== run_backed_item
    && manual_item_has_review_shape(item)
    && (
      !get_manual_item_type(run_backed_item)
      || !get_manual_item_type(item)
      || get_manual_item_type(item) === get_manual_item_type(run_backed_item)
    );
}

export function build_historical_manual_item(manual_items = []) {
  const items = Array.isArray(manual_items) ? manual_items : [];
  if (!items.length) return null;

  const run_backed_item = items.find((item) => manual_item_has_saved_run(item)) || null;
  const matching_support_item = run_backed_item
    ? items.find((item) => is_matching_support_item(run_backed_item, item)) || null
    : null;
  const fallback_support_item = items.find((item) => item !== run_backed_item && manual_item_has_review_shape(item)) || null;

  return merge_manual_items(
    run_backed_item || items.find((item) => manual_item_has_review_shape(item)) || items[0] || null,
    matching_support_item || fallback_support_item || null
  );
}
